import { InitColorsAction } from './colors'
import { InitEstimatesAction } from './estimates'
import { InitMainSectionAction } from './sections'
import { InitSettingsAction } from './settings'
import { InitTabAction } from './tabs'
import { InitTagsAction } from './tags'

export const InitEmptyProjectActions = [
  InitColorsAction,
  InitSettingsAction,
  InitTagsAction,
  InitTabAction,
  InitMainSectionAction,
  InitEstimatesAction,
]
